import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    width: '100%',
    height: '100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  },
  rnd: {
    border: '2px dashed #333',
    outline: 'none',
    '&:hover': {
      borderStyle: 'solid thin #999999',
    },
  },
  box: {
    width: '100%',
    height: '100%',
  },
  sidebar: {
    position: 'absolute',
    right: '-38px',
    top: '-2px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  listItem: {
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  drag: {
    '&:hover': {
      cursor: 'grab',
    },
    '&:active': {
      cursor: 'grabbing',
    },
  },
}))

export default useStyles
